module.exports = __webpack_public_path__ + "img/s5.ce83b8d2.jpg";